










import { Component } from 'vue-property-decorator'

import Field from './Field.vue'

@Component
export default class FieldNumber extends Field {
  get currentValue() {
    return parseInt(this.field.value, 10)
  }
}
